import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { Button, Form, Modal } from "semantic-ui-react";
import {
  deletePosition,
  editSportPosition,
} from "../../store/actions/athleteActions";

const EditSport = props => {
  const [sport, setSport] = useState(props.value);
  const [newPositions, setNewPositions] = useState({});
  const [oldPositions, setOldPositions] = useState({});
  const positions = props.positions;
  const [confirmationPopup, setConfirmationPopup] = useState(null);
  const dispatch = useDispatch();

  const handleSubmit = e => {
    e.preventDefault();
    if (oldPositions.length !== newPositions.length) {
    }
    if (!sport) {
      setNewPositions(newPositions === null ? oldPositions : newPositions);
      const sportInfo = {
        key: props.sportKey,
        value: props.sportValue,
        new: { sport: props.value, newPositions },
        old: { sport: props.value, positions: oldPositions },
      };
      dispatch(editSportPosition(sportInfo));

      setTimeout(props.close, 500);
      setNewPositions({});
      setOldPositions({});
    } else {
      setNewPositions(newPositions === null ? oldPositions : newPositions);
      const sportInfo = {
        key: props.sportKey,
        value: props.sportValue,
        new: { sport, newPositions },
        old: { sport: props.value, positions: oldPositions },
      };
      const myPromise = new Promise((resolve, reject) => {
        dispatch(editSportPosition(sportInfo));
      });
      myPromise.then(setTimeout(props.close, 500));
    }
    props.close();
  };

  const handlePositionChange = e => {
    const dum = {};

    positions.map((value, i) => {
      return (dum[value.key] = value.position);
    });
    setOldPositions(dum);
    const read = {};
    read[Number(e.target.id.slice(-1))] = e.target.value;
    for (let i in oldPositions) {
      if (!(i in newPositions)) {
        read[i] = oldPositions[i];
      }
    }
    setNewPositions({ ...newPositions, ...read });
  };

  const confirmationPopupHandler = deleteID => {
    setConfirmationPopup(deleteID);
  };

  const handleDelete = () => {
    const positionName = confirmationPopup[0];
    const sportName = confirmationPopup[1];
    dispatch(deletePosition(positionName, sportName));
    setConfirmationPopup(false);
    props.close();
  };

  const renderContent = (
    <Modal onClose={props.close} open={props.editSport}>
      <Modal.Content>
        <div className="AdminTopButtonsProgressContainer">
          <div className="AdminTopButtonsContainer button-mb">
            <Button
              floated="left"
              circular
              icon="close"
              onClick={props.close}
            />
            <Button
              floated="right"
              positive
              name="saveButton"
              content="Save"
              labelPosition="right"
              icon="check"
              onClick={handleSubmit}
            />
          </div>
        </div>

        <div className="edit-sport-section">
          <div className="AdminFormPersonalInfoContainer">
            <h3 className="text-center">Edit Sports & Postions</h3>
          </div>
          <div className="NewSchoolDetailsContainer">
            <Form className="mt-0">
              <div className="NewSchoolInfoContainer">
                <Form.Field required>
                  <label>Sport Name</label>
                  <input
                    placeholder=""
                    id="sportname"
                    required={true}
                    defaultValue={props.value}
                    onChange={e => setSport(e.target.value)}
                  />
                </Form.Field>
              </div>
              <div className="NewSchoolInfoContainer mb-check">
                <Form.Field required>
                  {positions.length !== 0 && <label>Postion Name</label>}
                  <ul className="positionInputs">
                    {positions.map(position => {
                      return (
                        <>
                          <li key={position.key}>
                            <div className="input-set-delete">
                              <input
                                className="input-cu"
                                key={position.key}
                                placeholder=""
                                id={`posname${position.key}`}
                                required={true}
                                defaultValue={position.position}
                                onChange={handlePositionChange}
                              />
                              <Button
                                circular
                                color="red"
                                icon="trash"
                                onClick={() =>
                                  confirmationPopupHandler([
                                    position.position,
                                    props.value,
                                  ])
                                }
                              />
                            </div>
                          </li>
                          {confirmationPopup && (
                            <Modal
                              className="delete-popup"
                              open={confirmationPopup}
                            >
                              <Modal.Content>
                                <p className="p1">
                                  Are you sure want to delete this '
                                  {confirmationPopup[0]}'?
                                </p>
                                <p className="p2">
                                  This process cannot be undone.
                                </p>
                                <div className="delete-modal-footer">
                                  <Button
                                    name="closeButton"
                                    content="Cancel"
                                    onClick={() => setConfirmationPopup(false)}
                                  />
                                  <Button
                                    color="red"
                                    name="saveButton"
                                    content="Delete"
                                    onClick={handleDelete}
                                  />
                                </div>
                              </Modal.Content>
                            </Modal>
                          )}
                        </>
                      );
                    })}
                  </ul>
                </Form.Field>
              </div>
            </Form>
          </div>
        </div>
      </Modal.Content>
    </Modal>
  );
  return positions && renderContent;
};

export default EditSport;